/**
 * Rich text section: heading + paragraphs on a plain background. No cards.
 */
export default function RichText({ section }) {
  const { eyebrow, heading, paragraphs = [], theme = "white" } = section;
  const bgClass = theme === "navy" ? "bg-mist-navy text-white" : theme === "off" ? "bg-mist-off" : "bg-white";
  const headingColor = theme === "navy" ? "text-white" : "text-mist-navy";
  const paraColor = theme === "navy" ? "text-white/75" : "text-mist-ink/75";

  return (
    <section className={`${bgClass} py-24 lg:py-32`}>
      <div className="container-mist">
        <div className="max-w-3xl">
          {heading && (
            <h2 className={`font-display text-3xl sm:text-4xl lg:text-[2.5rem] leading-[1.1] tracking-tight ${headingColor}`}>
              {heading}
            </h2>
          )}
          {(eyebrow || heading) && <div className="mt-4 gold-divider" />}
          <div className="mt-6 space-y-4">
            {paragraphs.map((p, i) => (
              <p key={i} className={`text-[15px] leading-relaxed ${paraColor}`}>
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
